import { useContext } from "react";
import { Grid } from '@mui/material';
import { CircleLoader, PageHeader } from "components";
import { UserGroupEditor, Results } from './components';
import { userGroupsContext } from './UserGroupsContext';


let UserGroups = () => {
    let service = useContext(userGroupsContext);


    return (
        <>
            <PageHeader pageTitle={"Gruppi utenti"}>
                <Grid item>
                    <UserGroupEditor />
                </Grid>
            </PageHeader>
            {service.isLoading && <CircleLoader />}
            {service.isLoading === false && <Results />}
        </>
    )
}

export default UserGroups;